import { useNavigateWithSearch } from "hooks/useNavigateWithSearch";
import AccordionTemplate from "components/accordions/accordion-template/AccordionTemplate";
import { getMonthLabel } from "utils/getMonthLabel";
import { pushGTMEvent } from "utils/gtmEvent";
import { GA_EVENT_CONFIGS } from "constants/gaEvents";
import { useContactInformation } from "hooks/useContactInformation";
import { ROUTES, CARD_FRAGMENTS } from "routes/constants";

const YourContactInformationAccordion = () => {
    const navigate = useNavigateWithSearch();
    const { contactData } = useContactInformation();

    const contactInformation = contactData?.contactInformation;

    const handleEdit = () => {
        pushGTMEvent(GA_EVENT_CONFIGS.REVIEW_EDIT_CONTACT);
        navigate(`${ROUTES.APPLICATION.CONTACT}${CARD_FRAGMENTS.CONTACT_INFORMATION}`);
    };

    return (
        <AccordionTemplate
            title="Your Contact Information"
            accordionName="your-review-information"
            defaultChecked={true}
            onEdit={handleEdit}
            dataTestId="your-contact-information-accordion"
        >
            <div className="flex flex-col gap-1 mb-4">
                <p className="text-base-content text-sm font-semibold">Name</p>
                <p className="text-base-content text-sm font-medium">
                    {contactInformation?.firstName} {contactInformation?.lastName}
                </p>
            </div>
            <div className="flex gap-16 mb-4">
                <div className="flex flex-col gap-2">
                    <div className="flex flex-col gap-1">
                        <p className="text-base-content text-sm font-semibold">Date of Birth</p>
                        <p className="text-base-content text-sm font-medium">
                            {getMonthLabel(contactInformation?.dateOfBirth?.month || "")} {contactInformation?.dateOfBirth?.day}
                            , {contactInformation?.dateOfBirth?.year}
                        </p>
                    </div>
                    <div className="flex flex-col gap-1">
                        <p className="text-base-content text-sm font-semibold">Phone Number</p>
                        <p className="text-base-content text-sm font-medium">{contactInformation?.phone}</p>
                    </div>
                </div>
                <div className="flex flex-col gap-2">
                    <div className="flex flex-col gap-1">
                        <p className="text-base-content text-sm font-semibold">Email Address</p>
                        <p className="text-base-content text-sm font-medium">{contactInformation?.email}</p>
                    </div>
                    <div className="flex flex-col gap-1">
                        <p className="text-base-content text-sm font-semibold">Type</p>
                        <p className="text-base-content text-sm font-medium">{contactInformation?.phoneType}</p>
                    </div>
                </div>
            </div>
            <div className="flex flex-col gap-1 mb-4">
                <p className="text-base-content text-sm font-semibold">Street Address</p>
                <p className="text-base-content text-sm font-medium blur-upscope">{contactInformation?.address}</p>
                <p className="text-base-content text-sm font-medium blur-upscope">
                    {contactInformation?.city}, {contactInformation?.state}, {contactInformation?.zipCode}
                </p>
            </div>
            {contactInformation?.aaaMemberNumber && (
                <div className="flex flex-col gap-1 mb-4">
                    <p className="text-base-content text-sm font-semibold">AAA Life Membership Number</p>
                    <p className="text-base-content text-sm font-medium">{contactInformation?.aaaMemberNumber}</p>
                </div>
            )}
        </AccordionTemplate>
    );
};

export default YourContactInformationAccordion;
